import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { SizePane } from 'page/ProfileScreen/SizeSlider/SizePane'
import { store } from 'store/store'
import { getShouldersConfig } from 'type/Identity'

export const ShouldersSlider = observer(() => {
  const form = store.profile.form
  const { min, max } = getShouldersConfig(form.gender)
  const value = form.shoulders

  const onChange = useLatestCallback((value: number) => {
    form.setShoulders(value)
  })

  return <SizePane label={i18n('Shoulders')} value={value}
    min={min} max={max} onChange={onChange} />
})
